import { useEkardoLazyQuery } from '@netfront/ekardo-content-library';

import { SEARCH_TAGS } from './useSearchTags.graphql';
import {
  ISeachTagsQueryGraphQLResponse,
  IHandleSeachTagsParams,
  IUseSeachTags,
  IUseSeachTagsOptions,
} from './useSearchTags.interfaces';

const useSearchTags = (options?: IUseSeachTagsOptions): IUseSeachTags => {
  const { fetchPolicy, onCompleted, onError, product, query, tokens } = options ?? ({} as IUseSeachTagsOptions);

  const [executeSearchTags, { loading: isLoading }] = useEkardoLazyQuery<ISeachTagsQueryGraphQLResponse>({
    options: {
      fetchPolicy: fetchPolicy ?? 'cache-and-network',
      onCompleted: (data) => {
        if (!onCompleted) {
          return;
        }
        
        const { tag: { searchTags} } = data;

        onCompleted({
         tags: searchTags
        });
      },
      onError,
    },
    product,
    query: query ?? SEARCH_TAGS,
    tokens,
  });

  const handleSeachTags = async ({ projectId }: IHandleSeachTagsParams) => {
    await executeSearchTags({
      variables: {
        projectId,
      },
    });
  };

  return {
    handleSeachTags,
    isLoading,
  };
};

export { useSearchTags };
